import React from 'react';
import PropTypes from 'prop-types';
import * as searchTypes from '../../constants/searchTypes';
import ShopSelectContainer from '../../containers/tools/ShopSelectContainer';
import ActionsContainer from '../../containers/tools/ActionsContainer';
import ZendeskContainer from '../../containers/tools/zendesk/ZendeskContainer';
import isEmpty from 'lodash/isEmpty';

const SHOP_SELECT_TOOL = 'SHOP_SELECT';
const ACTIONS_TOOL = 'ACTIONS';
const ZENDESK_TOOL = 'ZENDESK';

const getContentForTool = (toolName) => {
  switch (toolName) {
    case SHOP_SELECT_TOOL:
      return <ShopSelectContainer />;
    case ACTIONS_TOOL:
      return <ActionsContainer />;
    case ZENDESK_TOOL:
      return <ZendeskContainer />;
    default:
      return `Insert ${toolName} content here`;
  }
};

const Tools = ({ general, shopifyConfigs, ordersSearch }) => {
  const needsToSelectShop =
    Object.keys(shopifyConfigs || {}).length &&
    !ordersSearch.selectedShop &&
    isEmpty(ordersSearch.searchOrderShops) &&
    general.searchType === searchTypes.SEARCH_ORDERS;

  const selectedTool = general.selectedTool || ACTIONS_TOOL;

  return getContentForTool(needsToSelectShop ? SHOP_SELECT_TOOL : selectedTool);
};

Tools.propTypes = {
  general: PropTypes.shape({
    selectedTool: PropTypes.string,
    searchType: PropTypes.string,
  }).isRequired,
  shopifyConfigs: PropTypes.object,
  ordersSearch: PropTypes.object,
};

export default Tools;
